import { createSlice } from "@reduxjs/toolkit";
import {
  readLocalStorageJSON,
  writeLocalStorageJSON,
} from "../utils/safeLocalStorage";

const initialState = {
  appointments: readLocalStorageJSON("appointments", []),
};

const appointmentSlice = createSlice({
  name: "appointments",
  initialState,
  reducers: {
    setAppointments(state, action) {
      state.appointments = action.payload ?? [];
      writeLocalStorageJSON("appointments", state.appointments);
    },
    updateAppointment(state, action) {
      state.appointments = state.appointments.map((appointment) =>
        appointment.AppointmentID === action.payload.AppointmentID
          ? { ...appointment, ...action.payload }
          : appointment
      );
      writeLocalStorageJSON("appointments", state.appointments);
    },
    clearAppointments(state) {
      state.appointments = [];
      localStorage.removeItem("appointments");
    },
  },
});

export const { setAppointments, updateAppointment, clearAppointments } =
  appointmentSlice.actions;
export default appointmentSlice.reducer;
